module.exports = __webpack_public_path__ + "img/WhiteDoubleArrowRight.7333a8e3.svg";